import styled from "styled-components";

export const TabPanelText = styled.div`
    display: flex;
    align-items: center;
    padding: 5px 0;
    // margin-bottom: 0.5rem;
    
    svg {
        margin-right: 0.5rem;
        height: 0.8125rem;

        path {
            fill: ${props => props.iconColor ? props.iconColor : '#ccc'};
        }
    }

    p {
        font-size: 0.8125rem;
        font-weight: ${({ theme }) => theme.fontWeight.fw600};
        color: ${({ theme }) => theme.color.grayBold};
    }
`;

export const WrappBuyButton = styled.div`
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;

    button {
        max-width: 460px !important;
    }
`;

export const WrapperTabs = styled.div`
    // margin-top: 30px;
`;

export const ButtonActionRescue = styled.button`

    background-color: ${ props => props.buttonColor };
    width: 100%;
    border: 0;
    border-radius: 0.25rem;
    padding: 0.469rem 0.75rem;
    -webkit-box-shadow: 0 6px 8px 0 rgba(110,110,110,0.1);
    box-shadow: 0 6px 8px 0 rgba(110,110,110,0.1);

    a {
        color: #FFFFFF;
        position: relative;
        display: block;
        font-size: 0.875rem;
        font-weight: 700;
        width: 100%;
    }
`;

export const Description = styled.div`
    margin-top: 1.25rem;
    margin-bottom: ${props => props.marginBottom ? `1.875rem` : 0};
`;

export const DescriptionTitle = styled.h1`
    font-size: 0.875rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    color: ${({ theme }) => theme.color.black};
    margin-bottom: 0.625rem;
`;

export const DescriptionText = styled.p`
    font-size: 0.8125rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw500};
    color: ${({ theme }) => theme.color.black};
    margin-bottom: 0;
`;

export const LoadMoreButton = styled.button`
    color: ${props => props.textColor ? props.textColor : 'red'};
    border: 0;
    background-color: transparent;
    margin-top: .25rem;
`;

export const StoreListItem = styled.li`
    margin-bottom: 4px;
    display: flex;
    align-items: center;

    svg {
        height: 5px;
        width: auto !important;
        margin-right: 4px;

        path {
            fill: ${({ theme }) => theme.color.gray};
        }
    }
`;

export const ShowDate = styled.p`
    font-size: .8125rem;
    color: #545d5d;
    margin: .625rem 0;
    
    & > span {
        color: #545d5d;
    }
`